import { Phrases } from '@shared/model/locales.model';

export default {
  FailedToLogout: 'فشل تسجيل الخروج',
  LoggedOutSuccessfully: 'تم تسجيل الخروج بنجاح'
} as Phrases;
